'use client';

import ButtonElement from '@/components/organisms/announcement-bar/account-button/button';
import useDisclosure from '@/hooks/useDisclosure';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import React, { cloneElement, ReactElement, MouseEvent } from 'react';

interface MenuProps {
    children: React.ReactNode;
    Element: React.ComponentType<{ item: any; onOpen: () => void; onClose?:() => void,isExpanded?:any  }>;
    rootClassname?: string;
    classnames: string;
    data: any;
    header?:boolean
}

const Menu = ({ children, Element, rootClassname, classnames, data, header=false }: MenuProps) => {
    const { isOpen: isExpanded, onOpen: onExpand, onClose: onCollapse } = useDisclosure();
    const { ref } = useOnClickOutside(onCollapse);

    const handleChildClick = (event: MouseEvent) => {
        event.stopPropagation();
        onCollapse();
    };

    const renderChildrenWithCollapse = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            const typedChild = child as ReactElement<any>;
            return cloneElement(typedChild, {
                onClick: (event: MouseEvent) => {
                    if (typedChild.props.onClick) {
                        typedChild.props.onClick(event);
                    }
                    handleChildClick(event);
                }
            });
        }
        return child;
    });

    return (
        <div ref={ref} className={rootClassname || "relative z-[1001]"}>
            <Element isExpanded={isExpanded} item={data} onOpen={header ? onExpand : isExpanded ? onCollapse : onExpand} onClose={onCollapse} />
            {isExpanded && (
                <div onMouseLeave={()=> header && onCollapse()} className={classnames}>
                    {renderChildrenWithCollapse}
                </div>
            )}
        </div>
    );
}

export default Menu;
